import React from "react";
import css from "./ExploreSection.module.css";
import { Link } from "react-router-dom";

/**
 * ExploreSection - preview de biblioteca para a homepage
 * Props: videos (optional) — array com {id, title, description, youtubeId}
 * If no videos passed, renders 3 placeholder cards that link to /library
 */

export default function ExploreSection({ videos = [] }) {
  const items =
    videos && videos.length > 0
      ? videos.slice(0, 3)
      : [
          {
            id: "v1",
            title: "Respiração curta",
            description: "3 minutos de atenção à respiração",
            youtubeId: "Ca8p9RZdS6w",
          },
          {
            id: "v2",
            title: "Metáfora da folha",
            description: "Exercício de defusão com metáfora",
            youtubeId: "Ca8p9RZdS6w",
          },
          {
            id: "v3",
            title: "Ação por valores",
            description: "Pequenos passos para identificar valores",
            youtubeId: "Ca8p9RZdS6w",
          },
        ];

  return (
    <section className={css.root} aria-label="Explorar vídeos">
      <div className={css.inner}>
        <div className={css.header}>
          <div>
            <h3 className={css.title}>Explorar vídeos</h3>
            <p className={css.lead}>
              Vídeos curtos para trazer saúde ao seu dia a dia.
            </p>
          </div>

          {/* <div>
            <Link to="/library" className={css.cta}>
              Ver biblioteca
            </Link>
          </div> */}
        </div>

        <div className={css.grid}>
          {items.map((v) => (
            <Link to={`/video/${v.id}`} key={v.id} className={css.card}>
              <a href="">
                <div className={css.thumb}>
                  {/* if youtubeId exists use thumbnail, else placeholder */}
                  <img
                    src={
                      v.youtubeId
                        ? `https://img.youtube.com/vi/${v.youtubeId}/hqdefault.jpg`
                        : "/placeholder-video.png"
                    }
                    alt={v.title}
                  />
                </div>
              </a>
              <div className={css.body}>
                <div className={css.cardTitle}>{v.title}</div>
                <div className={css.cardDesc}>{v.description}</div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
